import React from 'react';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';

const DeleteTripForm = ({ handleSubmit, handleProcess, onCancel }) => (
  <>
    <Form onSubmit={handleSubmit(handleProcess)}>
      <p>Seguro de eliminar la programación del itinerario</p>
      <hr />
      <FormGroup row>
        <FormItem label="Observaciones" required>
          <Field
            name="observation"
            component={TextInput}
            type="textarea"
            placeholder="Observaciones"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter
        saveButtonColor="danger"
        saveButtonIcon="fa fa-trash"
        saveButtonText="Eliminar"
      >
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  </>
);

DeleteTripForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'DeleteTripForm',
})(DeleteTripForm);

export default connect(null, mapDispatchToProps)(formComponent);
